import DocumentPage from "../../../../invoice/DocumentPage";
import { verifactuDebitNoteConfig } from "./config";

const VerifactuDebitNote = () => (
  <DocumentPage config={verifactuDebitNoteConfig} />
);

export default VerifactuDebitNote;